module.exports = __webpack_public_path__ + "static/media/phaneroptera_nana_BD_010_APA.acfa55ae.png";